function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (n, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports, require("preact")) : "function" == typeof define && define.amd ? define(["exports", "preact"], t) : t((n = n || self).preactContext = {}, n.preact);
}(this, function (n, t) {
  "use strict";

  var i = {
    register: function register(n) {
      console.warn("Consumer used without a Provider");
    },
    unregister: function unregister(n) {},
    val: function val(n) {}
  };

  function r(n) {
    var t = n.children;
    return {
      child: 1 === t.length ? t[0] : null,
      children: t
    };
  }

  var _e,
      u = window && window.__extends || (_e = function e(n, t) {
    return (_e = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (n, t) {
      n.__proto__ = t;
    } || function (n, t) {
      for (var i in t) {
        t.hasOwnProperty(i) && (n[i] = t[i]);
      }
    })(n, t);
  }, function (n, t) {
    function i() {
      this.constructor = n;
    }

    _e(n, t), n.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i());
  });

  function o(n) {
    return r(n).child || "render" in n && n.render;
  }

  var c = 1073741823,
      f = function f() {
    return c;
  },
      s = 0;

  function a(n, e) {
    var a = "_preactContextProvider-" + s++;
    return {
      Provider: function (n) {
        function i(t) {
          var i = n.call(this, t) || this;
          return i.t = function (n, t) {
            var i = [],
                r = n,
                e = function e(n) {
              return 0 | t(r, n);
            };

            return {
              register: function register(n) {
                i.push(n), n(r, e(r));
              },
              unregister: function unregister(n) {
                i = i.filter(function (t) {
                  return t !== n;
                });
              },
              val: function val(n) {
                if (void 0 === n || n == r) return r;
                var t = e(n);
                return r = n, i.forEach(function (i) {
                  return i(n, t);
                }), r;
              }
            };
          }(t.value, e || f), i;
        }

        return u(i, n), i.prototype.getChildContext = function () {
          var n;
          return (n = {})[a] = this.t, n;
        }, i.prototype.componentDidUpdate = function () {
          this.t.val(this.props.value);
        }, i.prototype.render = function () {
          var n = r(this.props),
              i = n.child,
              e = n.children;
          return i || t.h("span", null, e);
        }, i;
      }(t.Component),
      Consumer: function (t) {
        function r(i, r) {
          var e = t.call(this, i, r) || this;
          return e.i = function (n, t) {
            var i = e.props.unstable_observedBits,
                r = void 0 === i || null === i ? c : i;
            0 != ((r |= 0) & t) && e.setState({
              value: n
            });
          }, e.state = {
            value: e.u().val() || n
          }, e;
        }

        return u(r, t), r.prototype.componentDidMount = function () {
          this.u().register(this.i);
        }, r.prototype.shouldComponentUpdate = function (n, t) {
          return this.state.value !== t.value || o(this.props) !== o(n);
        }, r.prototype.componentWillUnmount = function () {
          this.u().unregister(this.i);
        }, r.prototype.componentDidUpdate = function (n, t, r) {
          var e = r[a];
          e !== this.context[a] && ((e || i).unregister(this.i), this.componentDidMount());
        }, r.prototype.render = function () {
          var n = "render" in this.props && this.props.render,
              t = o(this.props);
          if (n && n !== t && console.warn("Both children and a render function are defined. Children will be used"), "function" == typeof t) return t(this.state.value);
          console.warn("Consumer is expecting a function as one and only child but didn't find any");
        }, r.prototype.u = function () {
          return this.context[a] || i;
        }, r;
      }(t.Component)
    };
  }

  var d = a;
  n["default"] = a, n.createContext = d, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});